import {Box, Typography, TypographyProps} from '@mui/material';
import {styled} from '@mui/material/styles';

import {zIndexes} from '../../../constants/index';

export const StyledBasketFooterWrapper = styled(Box)(({theme}) => ({
  width: '100%',
  padding: theme.spacing(0, 0, 2, 0),
  display: 'flex',
  flexDirection: 'column',
  boxShadow: theme.shadows[4],
  position: 'relative',
  zIndex: zIndexes.zIndexTen
}));

export const StyleFooterContentWrapper = styled(Box)<{isReactNativeView?: boolean}>(({isReactNativeView, theme}) => ({
  padding: isReactNativeView ? theme.spacing(1, 2, 1, 2) : theme.spacing(2, 4, 0, 4),
  gap: isReactNativeView ? theme.spacing(1) : theme.spacing(0),
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  '& > div': {
    flex: 1
  }
}));

export const StyledBox = styled(Box)(({theme}) => ({
  background: theme.palette.common.mds_global_color_red_15
}));

export const DeliveryFeesLabel = styled(Typography)(({theme}) => ({
  fontWeight: theme.typography.caption.fontWeight,
  fontSize: theme.typography.caption.fontSize,
  color: theme.palette.grey[900],
  lineHeight: theme.typography.caption.lineHeight
}));

export const BasketTotalPrice = styled(Typography)<TypographyProps>(({theme}) => ({
  fontWeight: theme.typography.h2.fontWeight,
  fontSize: theme.typography.h5.fontSize,
  color: theme.palette.primary.main,
  lineHeight: theme.spacing(0.25)
}));

export const VoucherWrapper = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderRadius: theme.spacing(1),
  position: 'relative',
  cursor: 'pointer',
  borderBottom: `1px solid ${theme.palette.divider}`
}));

export const VoucherIconBox = styled(Box)(({theme}) => ({
  backgroundColor: theme.palette.error.main,
  borderRadius: theme.spacing(0.75),
  padding: theme.spacing(0.75, 1),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: theme.spacing(3.5),
  height: theme.spacing(3.5)
}));

export const VoucherIconText = styled(Typography)(({theme}) => ({
  color: theme.palette.common.mds_global_color_white,
  fontSize: theme.spacing(1.25),
  fontWeight: theme.typography.fontWeightBold,
  lineHeight: 1,
  textTransform: 'uppercase'
}));

export const VoucherLabel = styled(Typography)(({theme}) => ({
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.secondary.main,
  fontSize: theme.typography.body1.fontSize,
  textTransform: 'capitalize'
}));

export const VoucherDiscountContainer = styled(Box)(() => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));

export const VoucherDiscountText = styled(Typography)(({theme}) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  color: theme.palette.common.mds_global_color_red_25,
  fontSize: theme.spacing(1.5),
  fontWeight: theme.typography.fontWeightBold,
  lineHeight: 1,
  zIndex: 2,
  pointerEvents: 'none'
}));

export const VoucherSelectText = styled(Typography)(({theme}) => ({
  color: theme.palette.grey[400],
  fontSize: theme.typography.body1.fontSize,
  fontWeight: theme.typography.fontWeightRegular,
  lineHeight: 1,
  textAlign: 'center'
}));
